export const environment = {
    host:'https://adminserv.stage.kidde-remotelync.com/api',
    login: 'login',
    self: 'self',
    password: 'password/change',
    user: 'user',
    location: 'location',
    device: 'device',
    deviceReports: 'device_reports',
    alert: 'alert',
    consent: 'consent',
    OTA: 'ota-job',
    upload: 'upload',
    iaqaas: 'iaqaas',
    subscriptions: 'subscription',
    history: 'history',
    defer: 'defer'
};